// extracted by mini-css-extract-plugin
export default {"header":"DocumentInputUpload_header__aqcC5","btn":"DocumentInputUpload_btn__tRxe-","text":"DocumentInputUpload_text__JEdFS","icon":"DocumentInputUpload_icon__vaPEo"};